// app/javascript/controllers/tax_planning_report_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["previewText", "previewColumns", "startMonth", "endMonth", "startYear", "endYear"]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ]

    const startMonthName = monthNames[this.startMonthTarget.value - 1]
    const endMonthName = monthNames[this.endMonthTarget.value - 1]

    const startYear = parseInt(this.startYearTarget.value)
    const endYear = parseInt(this.endYearTarget.value)

    // Format year range nicely
    let yearRange
    if (startYear === endYear) {
      yearRange = startYear.toString()
    } else {
      const years = []
      for (let year = startYear; year <= endYear; year++) {
        years.push(year)
      }

      if (years.length === 2) {
        yearRange = `${years[0]} and ${years[1]}`
      } else if (years.length > 2) {
        const lastYear = years.pop()
        yearRange = `${years.join(', ')} and ${lastYear}`
      }
    }

    const monthRange = this.startMonthTarget.value === this.endMonthTarget.value
      ? startMonthName
      : `${startMonthName}-${endMonthName}`

    this.previewTextTarget.textContent = `This will show ${monthRange} data for ${yearRange}`

    if (this.previewColumnsTarget) {
      if (startYear === endYear) {
        this.previewColumnsTarget.textContent = `Columns: ${startYear} Revenue (${monthRange}), ${startYear} Net Income (${monthRange}), ${startYear} Gross Profit (${monthRange})`
      } else {
        this.previewColumnsTarget.textContent = `Columns: ${startYear} Revenue (${monthRange}), ${startYear} Net Income (${monthRange}), ${endYear} Revenue (${monthRange}), ${endYear} Net Income (${monthRange}), etc.`
      }
    }
  }
}
